import {addLayer, getActiveLayers} from "@/helpers/ol/ol-layer-helper.js";
import {getBySelector} from "@/helpers/element-helper.js";

export function reloadOlSliderOptions() {

    if(!getBySelector('ol-slider')) {
        return
    }

    const activeLayers = getActiveLayers()

    let options = '<option value="">Kaart links</option>'

    activeLayers.map(layer => {
        if(layer.Type === 'WMTS' || layer.Type === 'WMS') {
            options += `<option value="${layer.BookmarkPresentationID}">${layer.DisplayName}</option>`
        }
    })

    const left = getBySelector('#selectCompareLayerLeft')
    const leftValue = left.value
    left.innerHTML = options
    left.value = leftValue

    options = '<option value="">Kaart rechts</option>'

    activeLayers.map(layer => {
        if(layer.Type === 'WMTS' || layer.Type === 'WMS') {
            options += `<option value="${layer.BookmarkPresentationID}">${layer.DisplayName}</option>`
        }
    })

    const right = getBySelector('#selectCompareLayerRight')
    const rightValue = right.value
    right.innerHTML = options
    right.value = rightValue
}
